module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Constituency List\" baCardClass=\"with-scroll\">\n        <constituency-list></constituency-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Constituency\" baCardClass=\"with-scroll\">\n        <constituency-form></constituency-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/constituencies/constituencies.component.html
// module id = 859
// module chunks = 8